import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {
  WB_UserGroupTypeRow
} from "../PA.Core/PAdbSchemaRows";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {
  esWB_Customer_Type,
  esWB_User_Group_Type
} from "../PA.Core/PAdbSchema";
import {ASync} from "../PA.Core/Basic/ASync";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {IwbUserGroupType} from "../PA.Core/PAdbSchemaRowsIF";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {UserGroupTypeBOValidations} from "./UserGroupTypeBO.Validations"
import _ = require('lodash');
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {RecordUtils} from "../PA.Core/Basic/Records";


export interface IUserGroupTypeLoadOpt {
  dbContext?: PAdbContext
}

const UserGroupTypeLoadOptions_default: IUserGroupTypeLoadOpt = {}

export class UserGroupTypeBO implements IBusinessObject {

  Identity: IdentityProvider;


  CreateOptions: any;

  LoadOptions: any;
  _bIsLoaded: boolean;
  _OnLoadComplete: Promise<IBusinessObject>;
  LoadProgressProvider: IProgressProvider;

  ValidateOptions: any;
  _bIsValidated: boolean;
  ValidateMessageProvider: IMessageProvider;
  ValidateProgressProvider: IProgressProvider;

  SaveOptions: any;
  _bIsSaved: boolean;
  SaveProgressProvider: IProgressProvider;

  DeleteOptions: any;
  _bIsDeleted: boolean;
  DeleteMessageProvider: IMessageProvider;
  DeleteProgressProvider: IProgressProvider;

  dbContext: PAdbContext;
  drWB_UserGroupType: WB_UserGroupTypeRow;

  _bMasterDataSetEnabled: boolean;

  dctAuditedDeletes: {[id:number]: number}
  constructor(options?: any) {

    this.CreateOptions = options || {};

    if ('dbContext' in this.CreateOptions)
      this.dbContext = this.CreateOptions.dbContext;

    this.Identity = new IdentityProvider({id: 0, name: 'New User Group Type'});

    this.LoadOptions = {};
    this._bIsLoaded = false;
    this._OnLoadComplete = undefined;
    this.LoadProgressProvider = new ProgressProvider('Loading', this);

    this.ValidateOptions = {};
    this._bIsValidated = false;
    this.ValidateMessageProvider = new MessageProvider();
    this.ValidateProgressProvider = new ProgressProvider("Validating", this);

    this.SaveOptions = {};
    this._bIsSaved = false;
    this.SaveProgressProvider = new ProgressProvider("Saving", this);

    this.DeleteOptions = {};
    this._bIsDeleted = false;
    this.DeleteMessageProvider = new MessageProvider();
    this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

    this.drWB_UserGroupType = undefined;

    this._bMasterDataSetEnabled = false

    this.dctAuditedDeletes = {}
  }

  get WB_UserGroupType(): WB_UserGroupTypeRow {
    return this.drWB_UserGroupType;
  }

  get bMasterDataSetEnabled(): boolean {
    return this._bMasterDataSetEnabled
  }

  //<editor-fold desc = "IBusinessObject operations">



  async Copy(options?: any): Promise<IBusinessObject> {
    const self = this

    const src: UserGroupTypeBO = this;

    const tgt = new UserGroupTypeBO({});
    await tgt.LoadNew()

    if (!tgt.bIsLoaded)
      throw new Error("Unable to create New User Group Type")

    RecordUtils.CopyProperties(tgt.dbContext, esWB_User_Group_Type,
        src.WB_UserGroupType, tgt.WB_UserGroupType,
        [],
        ['DELETED_DT', 'DELETED_IND'],
        {})

    tgt.WB_UserGroupType.cif.USRGRPM_ID = "CopyOf" + src.WB_UserGroupType.cif.USRGRPM_ID
    tgt.WB_UserGroupType.cif.USRGRPM_NAME = "Copy of " + src.WB_UserGroupType.cif.USRGRPM_NAME
    tgt.WB_UserGroupType.cif.WB_MDSET_ID = 0
    tgt.WB_UserGroupType.cif.PARENT_SHOW_IND = src.WB_UserGroupType.cif.PARENT_SHOW_IND
    tgt.WB_UserGroupType.cif.SCOPE_SHOW_IND = src.WB_UserGroupType.cif.SCOPE_SHOW_IND
    tgt.WB_UserGroupType.cif.ROLES_SHOW_IND = src.WB_UserGroupType.cif.ROLES_SHOW_IND
    tgt.WB_UserGroupType.cif.PLANS_SHOW_IND = src.WB_UserGroupType.cif.PLANS_SHOW_IND
    tgt.WB_UserGroupType.cif.CHILDREN_SHOW_IND = src.WB_UserGroupType.cif.CHILDREN_SHOW_IND

    tgt._bMasterDataSetEnabled = true

    tgt.Identity.setAll(tgt.WB_UserGroupType.cif.WB_USRGRPM_ID, tgt.WB_UserGroupType.cif.USRGRPM_ID, tgt.WB_UserGroupType.cif.USRGRPM_NAME);

    return tgt
  }

  async LoadNew(options?: any): Promise<IBusinessObject> {
    const self = this;
    this.LoadProgressProvider.start("Creating User Group Type");
    let olc = self._OnLoadComplete = (async () => {
      self.LoadOptions = options || {};

      try {
        if ('dbContext' in self.LoadOptions) {
          self.dbContext = self.LoadOptions.dbContext;
        } else {
          self.dbContext = new PAdbContext();
        }

        if (this.dbContext == null) {
          const sError = 'Unable to determine dbContext for new User Group Type.';
          self._OnLoadComplete = undefined;
          self.LoadProgressProvider.exception(sError);
          return this;
        }

        let newUserGroupTypeRow  = <WB_UserGroupTypeRow> await this.dbContext.createRecordWithKey(esWB_User_Group_Type)
        newUserGroupTypeRow.setDefaults();
        self.drWB_UserGroupType = newUserGroupTypeRow;
        self.dbContext.add(esWB_User_Group_Type, newUserGroupTypeRow);
        this.WB_UserGroupType.cif.WB_MDSET_ID = options?.wbMasterDataSetId || 0
        this.WB_UserGroupType.cif.USRGRPM_ID = options?.sId || this.WB_UserGroupType.cif.USRGRPM_ID || ''
        this.WB_UserGroupType.cif.USRGRPM_NAME = options?.sName || this.WB_UserGroupType.cif.USRGRPM_NAME || ''

        self.Identity.setAll(self.WB_UserGroupType.cif.WB_USRGRPM_ID, self.WB_UserGroupType.cif.USRGRPM_ID, self.WB_UserGroupType.cif.USRGRPM_NAME);
        self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
        self.Identity.listenToRecordUpdates(self.WB_UserGroupType, 'WB_USRGRPM_ID', 'USRGRPM_ID', 'USRGRPM_NAME')


        self.LoadProgressProvider.finish();
        self._bIsLoaded = true;

        self._OnLoadComplete = undefined;
        return self;
      } catch (err) {
        self.LoadProgressProvider.exception(err);
        return self;
      }

    })();
    return olc;
  }

  Load(anId: number | number, options?: object): Promise<IBusinessObject> {

    const self = this;

    let recordResolver: ESRecordResolver
    let recordResolverLoadPromise: Promise<void>

    self.LoadProgressProvider.start("Loading (" + anId + ")");

    self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

      if (self.bIsLoaded) {
        self.LoadProgressProvider.exception("User Group Type already loaded.")
        resolve(self); // "User Group already loaded.";
        return;
      }

      self.LoadOptions = options || {};
      _.defaults(self.LoadOptions, UserGroupTypeLoadOptions_default)


      if ('dbContext' in self.LoadOptions)
        self.dbContext = self.LoadOptions.dbContext;
      else if (_.isEmpty(self.dbContext)) {
        self.dbContext = new PAdbContext({});
      }

      if (_.isEmpty(self.dbContext)) {
        error("Unable to determine dbContext for User Group Type.")
        return;
      }

      if ('RecordResolver' in self.LoadOptions) {
        recordResolver = (<any>self.LoadOptions).RecordResolver
        recordResolverLoadPromise = ASync.resolve()
      } else {
        recordResolver = UserGroupTypeBO.createRecordResolver({dbContext: self.dbContext})
        recordResolverLoadPromise = UserGroupTypeBO.setupRecordResolver(recordResolver, [anId])
      }


      recordResolverLoadPromise
        .then(function () {
          let aUserGroupTypeRow: any = recordResolver.get(esWB_User_Group_Type, anId)

          if (_.isEmpty(aUserGroupTypeRow)) {
            error("User Group Type not Found");
            return;
          }

          self.drWB_UserGroupType = aUserGroupTypeRow;
          self.Identity.setAll(self.WB_UserGroupType.cif.WB_USRGRPM_ID, self.WB_UserGroupType.cif.USRGRPM_ID, self.WB_UserGroupType.cif.USRGRPM_NAME);
          self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
          self.Identity.listenToRecordUpdates(self.WB_UserGroupType, 'WB_USRGRPM_ID', 'USRGRPM_ID', 'USRGRPM_NAME')
          self._bIsLoaded = true
          self._OnLoadComplete = undefined
          self.LoadProgressProvider.finish()
          resolve(self)
        }).catch(function (err: any) {
        self._OnLoadComplete = undefined
        self.LoadProgressProvider.exception(err)
        error(err)
        return;
      });

    });

    return this._OnLoadComplete;
  }

  get OnLoadComplete(): Promise<IBusinessObject> {
    return this._OnLoadComplete;
  }

  get bIsLoaded(): boolean {
    return this._bIsLoaded;
  }

  async Validate(options?: any): Promise<IBusinessObject> {
    const self = this;
    this.ValidateMessageProvider.clearMessages();
    this.ValidateProgressProvider.start(
        'Validating ' + self.WB_UserGroupType.cif.USRGRPM_NAME + '(' + self.WB_UserGroupType.cif.USRGRPM_ID + ')'
    )

    try {
      if (self.dbContext == undefined) {
        const sError = 'Unable to determine dbContext to validate User Group Type.';
        self.ValidateProgressProvider.exception(sError);
        throw sError;
      }

      await UserGroupTypeBOValidations.Validate(self)

      if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
        self._bIsValidated = false;
      } else {
        self._bIsValidated = true;
      }
      self.ValidateProgressProvider.finish();

    } catch (err) {
      self._bIsValidated = false;
      self.ValidateProgressProvider.exception(err);

    }
    return self
  }

  get bIsValidated(): boolean {
    return this._bIsValidated;
  }


  Save(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(false, options)
  }


  SaveBatch(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(true, options)
  }

  private async SaveUsing(bBatch: boolean, options?: {bSkipValidations?: boolean}): Promise<IBusinessObject> {
    const self = this;
    const wbUserGroupType = <IwbUserGroupType>self.drWB_UserGroupType;
    this.SaveProgressProvider.start(
        'Saving ' + wbUserGroupType.USRGRPM_ID + '(' + wbUserGroupType.USRGRPM_NAME + ')'
    );

    try {
      if (_.isEmpty(self.dbContext)) {
        self._bIsSaved = false;
        const sError = 'Unable to determine dbContext to Save User Group Type.';
        self.SaveProgressProvider.exception(sError);
        return self;
      }

      self.SaveOptions = options || {};

      let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;

      if (bBatch) {
        saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
      } else {
        saveFunction = self.dbContext.Save.bind(self.dbContext);
      }

      if(!options?.bSkipValidations) {
        await self.Validate({})

        if (!self.bIsValidated) {
          self._bIsSaved = false;
          self.SaveProgressProvider.finish();
          return self
        }
      }

      await saveFunction(esWB_User_Group_Type, self.drWB_UserGroupType, {})

      if (bBatch) {
        self.dbContext.addBatchCompleteListener(() => {
          self._bIsSaved = true;
        });
      } else {
        self._bIsSaved = true;
      }

      self.SaveProgressProvider.finish();
    } catch (err) {
      self.SaveProgressProvider.exception(err);

    } finally {

    }

  }

  get bIsSaved(): boolean {
    return this._bIsSaved;
  }

//Delete------------------------------------------------------------------------
  Delete(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(true, options)
  }

  DeleteOnSave(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(false, options)
  }

  private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
    const self = this;
    const wbUserGroupType = <IwbUserGroupType>self.drWB_UserGroupType;

    this.DeleteMessageProvider.clearMessages();
    this.DeleteProgressProvider.start("Deleting " + wbUserGroupType.USRGRPM_NAME + "(" + wbUserGroupType.USRGRPM_ID + ")");

    try {
      // 1. Validate if we can delete the Master Data Set
      await UserGroupTypeBOValidations.ValidateDelete(self)
      if(self.DeleteMessageProvider.countMessages(MessageType.Error) > 0){
        self.DeleteProgressProvider.finish();
        return self
      }

      // 2. If Valid, mark all the records for deletion.
      self.drWB_UserGroupType.markDeleted()


      if (bSaveNow) {
        await self.SaveUsing(false)

        self._bIsDeleted = true;
        self.DeleteProgressProvider.finish();
        return (self);
      } else {
        self._bIsDeleted = true;
        self.DeleteProgressProvider.finish();
        return self;
      }

    } catch (err) {
      self.DeleteProgressProvider.exception(err)
      return self
    }
  }

  get bIsDeleted(): boolean {
    return this._bIsDeleted;
  }

  //</editor-fold>

  //<editor-fold desc = "IRecordResolver Operations">

  static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

    return new Promise<void>((resolve, error) => {
      recordResolver.findAllWithRelationships(esWB_User_Group_Type, ids).then((result) => {
        resolve()
      }).catch((err) => {
        error(err)
      })
    })
  }

  static concurrentLoadCountHint(): number {
    return 10;
  }

  static createRecordResolver(boLoadOptions: any): ESRecordResolver {

    let opts = boLoadOptions || {}
    let dbContext: PAdbContext

    if ('dbContext' in opts) {
      dbContext = opts.dbContext;
    } else {
      dbContext = new PAdbContext({});
    }
    const wrksp_options: CreateOptions = {
      standardConditions: {
      },
      dctIncludeBelongsToNamedRelations: {}
    }

    const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

    return aRecResolver;

  }

  //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass( UserGroupTypeBO, "UserGroupTypeBO", "User Group Type")